import "ngstorage";

import {WALKTHROUGH_STATES, TRIGGER_NEXT_EVENT_NAME, UPDATE_WORKFLOW_EVENT_NAME} from "../../variables";

class PreviewController {
  constructor($localStorage, $rootScope, $scope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events) {
    this.name = "preview";
    this.walkthroughState = WALKTHROUGH_STATES.PREVIEW;
    this.walkthroughStates = WALKTHROUGH_STATES;

    this.$localStorage = $localStorage;
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$auth = AuthService;
    this.$env = EnvService;
    this.$security = SecurityService;
    this.$timeout = $timeout;
    this.$tracking = TrackingService;
    //this.w2_options = ["Yes", "No"];
    this.$events = events;

    this.API_FIELDS = "subEvents.deduppedJobbles.id";

    this.SetNewWeeksOnChangeListener = this.$rootScope.$on("SetNewWeeksOnChange", ($event, params) => {
      if (this.event) {
        if (this.event.is_long_term === true) {
          this.setWeeks();
        }
      }
    });

    this.UpdateListener = this.$rootScope.$on(UPDATE_WORKFLOW_EVENT_NAME, ($event, params) => {
      console.log("ttttttttttt1");
      console.dir(this.event);

      if (this.event) {
        this.initMap();
        this.calculateTotalWage();
        if (this.event.is_long_term === true) {
          this.setWeeks();
        }

        if (this.event.shifts) {
          this.processShifts();
        }
      }
    });

    this.$scope.$on("$destroy", this.UpdateListener);
    this.$scope.$on("$destroy", this.SetNewWeeksOnChangeListener);
  }

  $onInit() {
    console.log("inititaing preview controller");
    console.dir(this.event);

    if (this.event) {
      this.syncWithApi();

      this.initMap();
      this.calculateTotalWage();

      if (this.event.is_long_term === true) {
        this.setWeeks();
      }

      if (this.event.shifts) {
        this.processShifts();
      }
    }
  }

  $onChanges() {
    if (this.event) {
      this.initMap();
      this.calculateTotalWage();

      if (this.event.shifts) {
        this.processShifts();
      }
    }
  }

  setWeeks() {
    let weeksInt = parseInt(this.event.numberOfWeeksToScheduleJob);
    console.log("do we have NaN");
    console.dir(isNaN(weeksInt));
    if (isNaN(weeksInt)) {
      this.weeks = null;
    } else {
      this.weeks = weeksInt + 1;
    }
  }

  calculateTotalWage() {
    if (!this.event) return;

    const currentUser = this.$auth.getUserData();
    const rate = currentUser.company.defaultPlan.jobblerFeePct;

    const pay = parseFloat(this.event.hourly_rate);
    const epi = 0.00001;

    if (this.event.shifts && this.event.shifts.length) {
      let hours = 0;

      this.event.shifts.forEach((shift) => {
        if (!shift) return;

        const startDate = new Date(`${shift.startDate} ${shift.startTime}`);
        const endDate = new Date(`${shift.endDate} ${shift.endTime}`);

        hours += (endDate.getTime() - startDate.getTime()) / 1000 / 60 / 60;
      });

      this.$timeout(() => {
        this.total_hours = hours;
        this.estimated_cost = Math.round((pay + epi) * 100 * hours) / 100;
      });
    }
  }

  initMap() {
    if (!this.event || !this.event.contactInfo) return;

    mapboxgl.accessToken = this.$env.EnvironmentConfig.mapbox;

    const lat = this.event.contactInfo.lat;
    const lng = this.event.contactInfo.lng;

    if (!this.lastLat || this.lastLat !== lat) {
      this.lastLat = lat;

      const map = new mapboxgl.Map({
        container: "preview-map",
        style: "mapbox://styles/mapbox/streets-v11",
        center: [lng, lat],
        zoom: 13,
      });

      const marker = new mapboxgl.Marker().setLngLat([lng, lat]).addTo(map);
    }
  }

  syncWithApi() {
    this.$timeout(() => {
      if (!this.event || !this.event.id) {
        console.log("WE DONT HAVE EVENT ID DO NOT SYNC");
      } else {
        console.log("GET JOBBLE ID");
        this.$events.getEventByIdWithFields(this.event.id, this.API_FIELDS).then((data) => {
          console.log("lets look at the response");
          console.dir(data);
          this.jobble_id = data.data.subEvents[0].deduppedJobbles[0].id;
          console.log("what is the jobble id");
          console.dir(this.jobble_id);
        });
      }
    }, 1000);
  }

  processShifts() {
    this.allShiftsValid = this.validateShifts();

    if (this.event.shifts.length === 1) {
      const shift = this.event.shifts[0];

      const valid = this.$events.validateWorflowShift(shift);

      if (!valid) return;

      const startMoment = moment(`${shift.startDate} ${shift.startTime}`);
      const endMoment = moment(`${shift.endDate} ${shift.endTime}`);

      const startTime = startMoment.format("ddd, MMM DD h:mmA");
      const endTime = endMoment.format("ddd, MMM DD h:mmA");

      const ret = shift.overnight ? startTime + " - " + endTime : startTime;

      const time = `${startMoment.format("h:mmA")} - ${endMoment.format("h:mmA")}`;

      const diffTime = endMoment.diff(startMoment);
      const durTime = moment.duration(diffTime);

      const durDays = durTime.days();
      const durHours = 24 * durDays + durTime.hours();
      const durMin = durTime.minutes();

      const duration = `${durHours ? durHours + " HR" : ""}${durHours > 1 ? "S" : ""}${durMin && durMin ? " " : ""}${durMin ? durMin + "MIN" : ""}`;
      const rawDuration = durHours + durMin / 60;

      this.jobbleFullTimeFrame = ret;
      this.jobbleHours = time;
      this.jobbleDuration = duration;
      this.jobbleOvernight = shift.overnight;
      this.unpaidBreak = shift.unpaidBreak;
    } else {
      this.shifts = this.event.shifts.sort((a, b) => {
        return new Date(`${a.startDate} ${a.startTime}`).getTime() - new Date(`${a.startDate} ${a.startTime}`).getTime();
      });

      this.shifts = this.shifts.map((shift) => {
        let start = new Date(`${shift.startDate} ${shift.startTime}`);
        let end = new Date(`${shift.endDate} ${shift.endTime}`);

        console.log("EACH SHIFT KKKK");
        console.dir(shift);

        let startMoment = moment(start);
        let endMoment = moment(end);

        let startDay = startMoment.format("M/DD");

        const diffTime = endMoment.diff(startMoment);
        const durTime = moment.duration(diffTime);

        const durDays = durTime.days();
        const durHours = 24 * durDays + durTime.hours();
        const durMin = durTime.minutes();

        const duration = `${durHours ? durHours + " HR" : ""}${durHours > 1 ? "S" : ""}${durMin && durMin ? " " : ""}${durMin ? durMin + "MIN" : ""}`;

        console.log("shift data each shift");
        console.dir(shift);

        return {
          dayOfWeek: startMoment.format("ddd"),
          date: startDay,
          startTime: startMoment.format("h:mmA"),
          endTime: endMoment.format("h:mmA"),
          duration,
          overnight: shift.overnight,
          unpaidBreak: shift.unpaidBreak,
        };
      });
    }
  }

  validateShifts() {
    let allValid = true;
    if (!this.event || !this.event.shifts || !this.event.shifts.length) {
      allValid = false;
      return allValid;
    }

    this.event.shifts.forEach((shift) => {
      const valid = this.$events.validateWorflowShift(shift);
      if (!valid) allValid = false;

      return valid;
    });

    if (allValid) {
      if (!this.$events.validateWorflowShiftsNonOverlapping(this.event.shifts)) {
        allValid = false;
      }
    }

    return allValid;
  }

  goNext() {
    this.$timeout(() => {
      this.savingStep = true;
    });

    this.$events.publishEvent(this.jobble_id, true).then((data) => {
      this.$timeout(() => {
        this.savingStep = false;
      });
      console.log("Published event:", data);
      this.$state.go("jobs-dashboard");
    });
  }
}

PreviewController.$inject = [
  "$localStorage",
  "$rootScope",
  "$scope",
  "$state",
  "$stateParams",
  "auth",
  "env",
  "security",
  "$timeout",
  "tracking",
  "events",
];

export default PreviewController;



// WEBPACK FOOTER //
// ./client/app/scenes/postashiftwalkthrough/scenes/preview/preview.controller.js